export default __webpack_public_path__ + "static/group-order-dont-bf27a068433674045cc6d82b6cce5ee8.png";